<em-item-revision-dataset-table
  [data]="relatedSpecification"
  [loading]="loading"
  [errorMsg]="error"
></em-item-revision-dataset-table>
